export default "__VITE_ASSET__dc1b0912__"